import { CategoryInfo } from "./category-info.model";

export class EventWithVenue {
	public storageIdEvent: number;
	public storageIdVenue: number;
	public lifecyclePhase: string;
	public title: string;
	public subtitle: string;
	public begin: string;
	public venueName: string;
	public locationCity: string;
	public locationPostalCode: string;
	public seatingplanUuid: string;
	public userSetHasVisualQuota: boolean;
	public uuidEvent: string;
	categoryInfos: CategoryInfo[];
}



// WEBPACK FOOTER //
// ./src/app/models/event-with-venue.model.ts